import { Action } from 'redux'

export const Actions = {
  NO_BREAK_ENABLE: '@nobreak/ENABLE',
  NO_BREAK_DISABLE: '@nobreak/DISABLE'
}

interface NoBreakInfo {
  user_login: string
}

export function noBreakAccessEnable(data: NoBreakInfo): Action {
  return {
    type: Actions.NO_BREAK_ENABLE,
    payload: data
  }
}

export function noBreakAccessDisable(data: NoBreakInfo): Action {
  return {
    type: Actions.NO_BREAK_DISABLE,
    payload: data
  }
}
